import { useTranslation } from 'react-i18next';
import { DropDownItem } from '@cp-shared-19/frontend-ui';
import { useSortedContractsCount } from './useContractsCount';
import { getCurrentStage } from '../../../utils';
import { dashboardPagePath } from '../paths';
import urls from '../../../config/urls';
import { currentBrand } from '../../../config';

const brandUrls = urls[getCurrentStage()];

export function useContractsCountDropdown(): DropDownItem[] {
    const { t } = useTranslation('brands');
    const { data, isLoading, loadingError } = useSortedContractsCount();

    if (isLoading || loadingError || !data) {
        return [];
    }

    return data.map(({ brand, numberOfContracts }) => {
        // Force login when user switches between contracts under same account
        const url =
            brand === currentBrand ? dashboardPagePath() : `${brandUrls[brand]}${dashboardPagePath()}?forceLogin=true`;

        return {
            href: url,
            url: url,
            label: `${t(brand)} (${numberOfContracts})`,
        };
    });
}
